import React from 'react';
import DtsPropertyBlock from './components/DtsPropertyBlock'; // TODO: Find out how to include asset files when building packages with lerna
// so we can pass the metadata in a form of a json file

export default {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var _attrs$header = attrs.header,
        header = _attrs$header === void 0 ? 'Example Sales Price Increase' : _attrs$header,
        _attrs$address = attrs.address,
        address = _attrs$address === void 0 ? '123 Main Street, Seattle, WA 78216' : _attrs$address,
        _attrs$withoutShowcas = attrs.withoutShowcaseAmount,
        withoutShowcaseAmount = _attrs$withoutShowcas === void 0 ? 'Sale without Showcase' : _attrs$withoutShowcas,
        _attrs$withoutShowcas2 = attrs.withoutShowcaseLabel,
        withoutShowcaseLabel = _attrs$withoutShowcas2 === void 0 ? '$442,000' : _attrs$withoutShowcas2,
        _attrs$withShowcaseAm = attrs.withShowcaseAmount,
        withShowcaseAmount = _attrs$withShowcaseAm === void 0 ? '$450,840' : _attrs$withShowcaseAm,
        _attrs$withShowcaseLa = attrs.withShowcaseLabel,
        withShowcaseLabel = _attrs$withShowcaseLa === void 0 ? 'Sale with Showcase' : _attrs$withShowcaseLa,
        _attrs$totalEarnings = attrs.totalEarnings,
        totalEarnings = _attrs$totalEarnings === void 0 ? '+$8,840' : _attrs$totalEarnings,
        _attrs$popoverTitle = attrs.popoverTitle,
        popoverTitle = _attrs$popoverTitle === void 0 ? 'Listing Showcase' : _attrs$popoverTitle,
        _attrs$popoverContent = attrs.popoverContent,
        popoverContent = _attrs$popoverContent === void 0 ? 'Showcase listings compared to similar non-Showcase listings on Zillow. Estimates are based on the Zestimate and data from homes sold with Showcase.' : _attrs$popoverContent,
        _attrs$footerText = attrs.footerText,
        footerText = _attrs$footerText === void 0 ? "This is an example scenario. Dollar amounts will differ based on your home's sales price." : _attrs$footerText;
    return /*#__PURE__*/React.createElement(DtsPropertyBlock, {
      zpid: "12345",
      header: header,
      address: address,
      withoutShowcaseAmount: withoutShowcaseAmount,
      withoutShowcaseLabel: withoutShowcaseLabel,
      withShowcaseAmount: withShowcaseAmount,
      withShowcaseLabel: withShowcaseLabel,
      totalEarnings: totalEarnings,
      popoverTitle: popoverTitle,
      popoverContent: popoverContent,
      footerText: footerText
    });
  },
  metadata: {
    schema: 'https://schemas.wp.org/trunk/block.json',
    version: '1.0',
    name: 'seller-tech/custom-dts-block',
    title: 'Showcase DTS Block',
    description: 'Block that shows DTS property information',
    icon: 'businessperson',
    keywords: ['showcase', 'dts', 'block', 'property'],
    category: 'more',
    attributes: {
      header: {
        type: 'string',
        label: 'Header',
        default: 'Example Sales Price Increase',
        control: 'text'
      },
      address: {
        type: 'string',
        label: 'Address',
        default: '123 Main Street, Seattle, WA 78216',
        control: 'text'
      },
      withShowcaseLabel: {
        type: 'string',
        label: 'With Showcase Label',
        default: 'Sale with Showcase',
        control: 'text'
      },
      withShowcaseAmount: {
        type: 'string',
        label: 'With Showcase Amount',
        default: '$450,840',
        control: 'text'
      },
      withoutShowcaseLabel: {
        type: 'string',
        label: 'Without Showcase Label',
        default: 'Sale without Showcase',
        control: 'text'
      },
      withoutShowcaseAmount: {
        type: 'string',
        label: 'Without Showcase Amount',
        default: '$442,000',
        control: 'text'
      },
      totalEarnings: {
        type: 'string',
        label: 'Total earnings',
        default: '+$8,840',
        control: 'text'
      },
      footerText: {
        type: 'string',
        label: 'Footer text',
        default: "This is an example scenario. Dollar amounts will differ based on your home's sales price.",
        control: 'text'
      },
      popoverContent: {
        type: 'string',
        label: 'Popover content',
        default: 'Showcase listings compared to similar non-Showcase listings on Zillow. Estimates are based on the Zestimate and data from homes sold with Showcase.',
        control: 'text'
      },
      popoverTitle: {
        type: 'string',
        label: 'Popover title',
        default: 'Listing Showcase',
        control: 'text'
      }
    }
  }
};
//# sourceMappingURL=index.js.map